<template>
  <div>
    <div class="page-title">New Creator</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="create"
      btnText="Add Creator"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.participants.page";
export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.User.new();
      this.form = data;
    },
    async create() {
      await this.$api.User.create(this.form);
      this.$router.push("/users/participants");
    },
  },
};
</script>

<style></style>
